import { SkroutzOrdersGridView } from '~/components/order/skroutz/grid';
import { PageContainer } from '~/components/page-container';

export function SkroutzOrders() {
	return (
		<PageContainer>
			<SkroutzOrdersGridView />
		</PageContainer>
	);
}
